import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// =====================================================
// GLOBAL TRANSLATIONS
// =====================================================
const translations = {

  // ===== FSM (Field Service Management) =====
  fsm: {
    ar: {
      equipment_registry: 'سجل المعدات',
      manage_equipment: 'إدارة جميع المعدات والأصول المُصانة',
      add_equipment: '+ إضافة معدة',
      edit_equipment: 'تعديل المعدة',
      new_equipment: 'تسجيل معدة جديدة',
      equipment: 'المعدات',
      total_equipment: 'إجمالي المعدات',
      clients: 'العملاء',
      locations: 'المواقع',
      warranty_expiring: 'ضمان ينتهي قريباً',
      breakdown_alert: 'تنبيه أعطال',
      search_equipment: 'بحث في المعدات...',
      all_categories: 'جميع الفئات',
      all_clients: 'جميع العملاء',
      all_status: 'جميع الحالات',
      qr_code: 'كود QR',
      category: 'الفئة',
      client: 'العميل',
      location: 'الموقع',
      status: 'الحالة',
      warranty: 'الضمان',
      actions: 'إجراءات',
      active: 'نشط',
      inactive: 'غير نشط',
      maintenance: 'صيانة',
      retired: 'متقاعد',
      brand: 'العلامة التجارية',
      model: 'الموديل',
      serial_number: 'الرقم التسلسلي',
      installation_date: 'تاريخ التركيب',
      warranty_expiry: 'انتهاء الضمان',
      floor: 'الدور',
      unit: 'الوحدة',
      notes: 'ملاحظات',
      save: 'حفظ',
      saving: 'جاري الحفظ...',
      cancel: 'إلغاء',
      edit: 'تعديل',
      delete: 'حذف',
      close: 'إغلاق',
      loading: 'جاري التحميل...',
      no_equipment: 'لا توجد معدات',
      add_first: 'أضف أول معدة للبدء',
      overview: 'نظرة عامة',
      photos: 'الصور',
      checklist: 'قائمة الفحص',
      equipment_details: 'تفاصيل المعدة',
      location_client: 'الموقع والعميل',
      visit_stats: 'إحصائيات الزيارات',
      total_visits: 'إجمالي الزيارات',
      last_visit: 'آخر زيارة',
      next_visit: 'الزيارة القادمة',
      no_visits_yet: 'لا توجد زيارات بعد',
      not_scheduled: 'غير مجدولة',
      breakdowns_12m: 'أعطال (12 شهر)',
      download_png: 'تحميل PNG',
      scan_qr_info: 'اطبع كود QR وألصقه على المعدة. يمكن للفنيين مسحه بالتطبيق، والعملاء يمكنهم مسحه للتحقق من الضمان أو الإبلاغ عن عطل.',
      default_checklist: 'قائمة الفحص الافتراضية لـ',
      no_checklist: 'لا توجد قائمة فحص لهذه الفئة',
      no_photos: 'لا توجد صور بعد',
      warranty_active: 'الضمان ساري',
      warranty_expired: 'الضمان منتهي',
      select_client: 'اختر العميل...',
      select_location: 'اختر الموقع (اختياري)...',
      select_category: 'اختر الفئة...',
      client_location: 'العميل والموقع',
      equipment_info: 'بيانات المعدة',
      name_en: 'الاسم (إنجليزي)',
      name_ar: 'الاسم (عربي)',
      // FSM Clients
      fsm_clients: 'عملاء الخدمة الميدانية',
      click_locations_equipment: 'انقر 📍 للمواقع، 🔧 للمعدات',
      add_client: '+ إضافة عميل',
      edit_client: 'تعديل العميل',
      new_client: 'عميل جديد',
      search_clients: 'بحث في العملاء...',
      company: 'الشركة',
      contact: 'جهة الاتصال',
      phone: 'الهاتف',
      city: 'المدينة',
      type: 'النوع',
      company_type: 'شركة',
      individual_type: 'فرد',
      code: 'الكود',
      no_clients: 'لا يوجد عملاء بعد',
      // Client Form Sections
      basic_info: 'البيانات الأساسية',
      client_code: 'كود العميل',
      also_vendor: 'عميل ومورد',
      price_list_only: 'أصناف قائمة الأسعار فقط',
      prevent_credit: 'منع أجل',
      financial: 'المالية',
      balance: 'الرصيد',
      loyalty_balance: 'رصيد الولاء',
      credit_limit: 'حد الائتمان',
      category_1: 'الفئة',
      category_2: 'الفئة الثانية',
      contract_from: 'تاريخ التعاقد من',
      contract_to: 'تاريخ التعاقد إلى',
      tax_registration: 'الضرائب والتسجيل',
      tax_number: 'رقم التسجيل الضريبي',
      commercial_reg: 'رقم السجل التجاري',
      tax_file: 'رقم الملف الضريبي',
      tax_code: 'كود الضريبة',
      sub_tax_code: 'كود الضريبة الفرعي',
      tax_exemption: 'الإعفاء الضريبي',
      contact_info: 'بيانات الاتصال',
      contact_name: 'اسم جهة الاتصال',
      contact_ar: 'جهة الاتصال (عربي)',
      email: 'البريد الإلكتروني',
      website: 'الموقع الإلكتروني',
      alt_phone: 'هاتف بديل',
      fax: 'فاكس',
      salesperson: 'البائع',
      address: 'العنوان',
      address_en: 'العنوان (إنجليزي)',
      address_ar: 'العنوان (عربي)',
      country: 'الدولة',
      province: 'المحافظة',
      district: 'المنطقة / الحي',
      street: 'الشارع',
      building: 'المنزل',
      apartment: 'الشقة',
      postal_code: 'الرمز البريدي',
      landmark: 'علامة مميزة',
      additional: 'إضافي',
      activity_type: 'نوع النشاط',
      shipping_method: 'الشحن عن طريق',
      reference: 'المرجع',
      additional_info: 'معلومات إضافية',
      // Locations
      add_location: '+ إضافة موقع',
      edit_location: 'تعديل الموقع',
      new_location: 'موقع جديد',
      no_locations: 'لا توجد مواقع بعد',
      access_notes: 'ملاحظات الوصول',
      gps_lat: 'خط العرض',
      gps_lng: 'خط الطول',
      deactivate_location: 'هل تريد إلغاء تفعيل هذا الموقع؟',
      unit_placeholder: 'مثال 301',
      floor_placeholder: 'مثال 3',
      brand_placeholder: 'مثال Carrier',
      model_placeholder: 'مثال 42QHC024',
      serial_placeholder: 'مثال CAR2024001',
      notes_placeholder: 'ملاحظات داخلية عن هذه المعدة...',
      client_code_placeholder: 'مثال 410101',
      name_en_placeholder: 'مثال Split AC - Reception',
      scan_url: 'رابط المسح',
      add_checklist_item: 'أضف عنصر قائمة فحص...',
      required_fields: 'العميل والفئة واسم المعدة مطلوبين',
      save_failed: 'فشل الحفظ',
      network_err: 'خطأ في الشبكة',
      deactivate: 'إلغاء التفعيل',
      activate: 'تفعيل',
      more: 'المزيد',
      add: 'إضافة',
      // Categories
      equipment_categories: 'فئات المعدات',
      manage_categories: 'إدارة أنواع المعدات وقوائم الفحص',
      add_category: '+ إضافة فئة',
      edit_category: 'تعديل الفئة',
      new_category: 'فئة جديدة',
      icon_emoji: 'الأيقونة (إيموجي)',
      sort_order: 'ترتيب العرض',
      description: 'الوصف',
      checklist_builder: 'قائمة الفحص الافتراضية',
      add_item: 'إضافة',
      add_checklist_item: 'أضف عنصر فحص...',
      deactivate: 'إلغاء تفعيل',
      activate: 'تفعيل',
      maintenance_plans: 'خطط الصيانة',
      maintenance_plans_desc: 'جدولة الصيانة الدورية للمعدات',
      new_plan: 'خطة جديدة',
      edit_plan: 'تعديل خطة الصيانة',
      create_plan: 'إنشاء خطة',
      update_plan: 'تحديث الخطة',
      total_plans: 'إجمالي الخطط',
      active_plans: 'نشطة',
      paused_plans: 'متوقفة',
      overdue: 'متأخرة',
      due_this_week: 'مستحقة هذا الأسبوع',
      plan_title: 'العنوان',
      search_plans: 'بحث في الخطط...',
      no_plans: 'لا توجد خطط صيانة',
      recurrence: 'التكرار',
      recurrence_schedule: 'جدول التكرار',
      recurrence_type: 'نوع التكرار',
      interval: 'الفترة',
      day_of_period: 'اليوم',
      daily: 'يومي',
      weekly: 'أسبوعي',
      monthly: 'شهري',
      quarterly: 'ربع سنوي',
      semi_annual: 'نصف سنوي',
      annual: 'سنوي',
      custom: 'مخصص',
      every: 'كل',
      next_due: 'الاستحقاق التالي',
      estimated_hours: 'المدة المقدرة (ساعات)',
      auto_work_order: 'إنشاء أمر عمل تلقائي',
      auto_generate_wo_label: 'إنشاء أوامر عمل تلقائياً عند الاستحقاق',
      advance_days: 'إنشاء أمر عمل (أيام قبل الاستحقاق)',
      add_checklist_item: 'إضافة عنصر فحص...',
      instructions_en: 'التعليمات (EN)',
      instructions_ar: 'التعليمات (AR)',
      no_equipment_for_client: 'لا توجد معدات لهذا العميل',
      selected: 'محدد',
      equipment_count: 'المعدات',
      no_contract: 'بدون عقد',
      confirm_delete: 'هل أنت متأكد من حذف هذه الخطة؟',
      title_en: 'العنوان (EN)',
      title_ar: 'العنوان (AR)',
      basic_info: 'البيانات الأساسية',
      select_client: 'اختر العميل',
      contract: 'العقد',
      priority: 'الأولوية',
      low: 'منخفضة',
      medium: 'متوسطة',
      high: 'عالية',
      critical: 'حرجة',
      start_date: 'تاريخ البدء',
      end_date: 'تاريخ الانتهاء',
      all_statuses: 'كل الحالات',
      paused: 'متوقفة',
      completed: 'مكتملة',
      cancelled: 'ملغاة',
      loading: 'جاري التحميل...',
      edit: 'تعديل',
      delete: 'حذف',
      fill_required_fields: 'يرجى ملء جميع الحقول المطلوبة',
      generate_wo: 'إنشاء أمر عمل',
      assigned_team: 'الفريق المعين',
      equipment_selection: 'اختيار المعدات',
      checklist: 'قائمة الفحص',
      instructions: 'التعليمات',
      save: 'حفظ',
      cancel: 'إلغاء',
    },
    en: {
      equipment_registry: 'Equipment Registry',
      manage_equipment: 'Manage all maintained equipment and assets',
      add_equipment: '+ Add Equipment',
      edit_equipment: 'Edit Equipment',
      new_equipment: 'Register New Equipment',
      equipment: 'Equipment',
      total_equipment: 'Total Equipment',
      clients: 'Clients',
      locations: 'Locations',
      warranty_expiring: 'Warranty Expiring',
      breakdown_alert: 'Breakdown Alert',
      search_equipment: 'Search equipment...',
      all_categories: 'All Categories',
      all_clients: 'All Clients',
      all_status: 'All Status',
      qr_code: 'QR Code',
      category: 'Category',
      client: 'Client',
      location: 'Location',
      status: 'Status',
      warranty: 'Warranty',
      actions: 'Actions',
      active: 'Active',
      inactive: 'Inactive',
      maintenance: 'Maintenance',
      retired: 'Retired',
      brand: 'Brand',
      model: 'Model',
      serial_number: 'Serial Number',
      installation_date: 'Installation Date',
      warranty_expiry: 'Warranty Expiry',
      floor: 'Floor',
      unit: 'Unit',
      notes: 'Notes',
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      loading: 'Loading...',
      no_equipment: 'No equipment found',
      add_first: 'Add your first equipment to get started',
      overview: 'Overview',
      photos: 'Photos',
      checklist: 'Checklist',
      equipment_details: 'Equipment Details',
      location_client: 'Location & Client',
      visit_stats: 'Visit Stats',
      total_visits: 'Total Visits',
      last_visit: 'Last Visit',
      next_visit: 'Next Visit',
      no_visits_yet: 'No visits yet',
      not_scheduled: 'Not scheduled',
      breakdowns_12m: 'Breakdowns (12mo)',
      download_png: 'Download PNG',
      scan_qr_info: 'Print this QR code and affix it to the equipment. Technicians can scan it with the mobile app, and customers can scan to check warranty status or report faults.',
      default_checklist: 'Default Maintenance Checklist for',
      no_checklist: 'No checklist defined for this category',
      no_photos: 'No photos yet',
      warranty_active: 'Warranty Active',
      warranty_expired: 'Warranty Expired',
      select_client: 'Select client...',
      select_location: 'Select location (optional)...',
      select_category: 'Select category...',
      client_location: 'Client & Location',
      equipment_info: 'Equipment Details',
      name_en: 'Name (English)',
      name_ar: 'Name (Arabic)',
      fsm_clients: 'FSM Clients',
      click_locations_equipment: 'Click 📍 for locations, 🔧 for equipment',
      add_client: '+ Add Client',
      edit_client: 'Edit Client',
      new_client: 'New Client',
      search_clients: 'Search clients...',
      company: 'Company',
      contact: 'Contact',
      phone: 'Phone',
      city: 'City',
      type: 'Type',
      company_type: 'Company',
      individual_type: 'Individual',
      code: 'Code',
      no_clients: 'No clients yet',
      basic_info: 'Basic Information',
      client_code: 'Client Code',
      also_vendor: 'Also Vendor',
      price_list_only: 'Price List Only',
      prevent_credit: 'Prevent Credit',
      financial: 'Financial',
      balance: 'Balance',
      loyalty_balance: 'Loyalty Balance',
      credit_limit: 'Credit Limit',
      category_1: 'Category',
      category_2: 'Category 2',
      contract_from: 'Contract From',
      contract_to: 'Contract To',
      tax_registration: 'Tax & Registration',
      tax_number: 'Tax Number',
      commercial_reg: 'Commercial Reg No.',
      tax_file: 'Tax File No.',
      tax_code: 'Tax Code',
      sub_tax_code: 'Sub Tax Code',
      tax_exemption: 'Tax Exemption',
      contact_info: 'Contact Information',
      contact_name: 'Contact Name',
      contact_ar: 'Contact (Arabic)',
      email: 'Email',
      website: 'Website',
      alt_phone: 'Alt Phone',
      fax: 'Fax',
      salesperson: 'Salesperson',
      address: 'Address',
      address_en: 'Address (English)',
      address_ar: 'Address (Arabic)',
      country: 'Country',
      province: 'Province',
      district: 'District',
      street: 'Street',
      building: 'Building',
      apartment: 'Apartment',
      postal_code: 'Postal Code',
      landmark: 'Landmark',
      additional: 'Additional',
      activity_type: 'Activity Type',
      shipping_method: 'Shipping Method',
      reference: 'Reference',
      additional_info: 'Additional Info',
      add_location: '+ Add Location',
      edit_location: 'Edit Location',
      new_location: 'New Location',
      no_locations: 'No locations yet',
      access_notes: 'Access Notes',
      gps_lat: 'GPS Latitude',
      gps_lng: 'GPS Longitude',
      deactivate_location: 'Deactivate this location?',
      unit_placeholder: 'e.g. 301',
      floor_placeholder: 'e.g. 3',
      brand_placeholder: 'e.g. Carrier',
      model_placeholder: 'e.g. 42QHC024',
      serial_placeholder: 'e.g. CAR2024001',
      notes_placeholder: 'Internal notes about this equipment...',
      client_code_placeholder: 'e.g. 410101',
      name_en_placeholder: 'e.g. Split AC - Reception',
      scan_url: 'Scan URL',
      add_checklist_item: 'Add checklist item...',
      required_fields: 'Client, Category, and Equipment Name are required',
      save_failed: 'Failed to save',
      network_err: 'Network error',
      deactivate: 'Deactivate',
      activate: 'Activate',
      more: 'more',
      add: 'Add',
      equipment_categories: 'Equipment Categories',
      manage_categories: 'Manage equipment types and default checklists',
      add_category: '+ Add Category',
      edit_category: 'Edit Category',
      new_category: 'New Category',
      icon_emoji: 'Icon (Emoji)',
      sort_order: 'Sort Order',
      description: 'Description',
      checklist_builder: 'Default Maintenance Checklist',
      add_item: 'Add',
      add_checklist_item: 'Add checklist item...',
      deactivate: 'Deactivate',
      activate: 'Activate',

    }
  },
  // ===== FSM (Field Service Management) =====
  fsm: {
    ar: {
      equipment_registry: 'سجل المعدات', manage_equipment: 'إدارة جميع المعدات والأصول المُصانة',
      add_equipment: '+ إضافة معدة', edit_equipment: 'تعديل المعدة', new_equipment: 'تسجيل معدة جديدة',
      equipment: 'المعدات', total_equipment: 'إجمالي المعدات', clients: 'العملاء', locations: 'المواقع',
      warranty_expiring: 'ضمان ينتهي قريباً', breakdown_alert: 'تنبيه أعطال',
      search_equipment: 'بحث في المعدات...', all_categories: 'جميع الفئات', all_clients: 'جميع العملاء', all_status: 'جميع الحالات',
      qr_code: 'كود QR', category: 'الفئة', client: 'العميل', location: 'الموقع', status: 'الحالة', warranty: 'الضمان', actions: 'إجراءات',
      active: 'نشط', inactive: 'غير نشط', maintenance: 'صيانة', retired: 'متقاعد',
      brand: 'العلامة التجارية', model: 'الموديل', serial_number: 'الرقم التسلسلي',
      installation_date: 'تاريخ التركيب', warranty_expiry: 'انتهاء الضمان', floor: 'الدور', unit: 'الوحدة',
      notes: 'ملاحظات', save: 'حفظ', saving: 'جاري الحفظ...', cancel: 'إلغاء', edit: 'تعديل', delete: 'حذف', close: 'إغلاق',
      loading: 'جاري التحميل...', no_equipment: 'لا توجد معدات', add_first: 'أضف أول معدة للبدء',
      overview: 'نظرة عامة', photos: 'الصور', checklist: 'قائمة الفحص',
      equipment_details: 'تفاصيل المعدة', location_client: 'الموقع والعميل', visit_stats: 'إحصائيات الزيارات',
      total_visits: 'إجمالي الزيارات', last_visit: 'آخر زيارة', next_visit: 'الزيارة القادمة',
      no_visits_yet: 'لا توجد زيارات بعد', not_scheduled: 'غير مجدولة', breakdowns_12m: 'أعطال (12 شهر)',
      download_png: 'تحميل PNG', no_checklist: 'لا توجد قائمة فحص لهذه الفئة', no_photos: 'لا توجد صور بعد',
      warranty_active: 'الضمان ساري', warranty_expired: 'الضمان منتهي',
      select_client: 'اختر العميل...', select_location: 'اختر الموقع (اختياري)...', select_category: 'اختر الفئة...',
      client_location: 'العميل والموقع', equipment_info: 'بيانات المعدة', name_en: 'الاسم (إنجليزي)', name_ar: 'الاسم (عربي)',
      scan_qr_info: 'اطبع كود QR وألصقه على المعدة. يمكن للفنيين مسحه بالتطبيق، والعملاء يمكنهم مسحه للتحقق من الضمان.',
      default_checklist_for: 'قائمة الفحص الافتراضية لـ',
      fsm_clients: 'عملاء الخدمة الميدانية', click_info: 'انقر 📍 للمواقع، 🔧 للمعدات',
      add_client: '+ إضافة عميل', edit_client: 'تعديل العميل', new_client: 'عميل جديد', search_clients: 'بحث في العملاء...',
      company: 'الشركة', contact: 'جهة الاتصال', phone: 'الهاتف', city: 'المدينة', type: 'النوع',
      company_type: 'شركة', individual_type: 'فرد', code: 'الكود', no_clients: 'لا يوجد عملاء بعد',
      basic_info: 'البيانات الأساسية', client_code: 'كود العميل', also_vendor: 'عميل ومورد',
      price_list_only: 'أصناف قائمة الأسعار فقط', prevent_credit: 'منع أجل',
      financial: 'المالية', balance: 'الرصيد', loyalty_balance: 'رصيد الولاء', credit_limit: 'حد الائتمان',
      category_1: 'الفئة', category_2: 'الفئة الثانية', contract_from: 'تاريخ التعاقد من', contract_to: 'تاريخ التعاقد إلى',
      tax_registration: 'الضرائب والتسجيل', tax_number: 'رقم التسجيل الضريبي', commercial_reg: 'رقم السجل التجاري',
      tax_file: 'رقم الملف الضريبي', tax_code: 'كود الضريبة', sub_tax_code: 'كود الضريبة الفرعي', tax_exemption: 'الإعفاء الضريبي',
      contact_info: 'بيانات الاتصال', contact_name: 'اسم جهة الاتصال', contact_ar: 'جهة الاتصال (عربي)',
      email: 'البريد الإلكتروني', website: 'الموقع الإلكتروني', alt_phone: 'هاتف بديل', fax: 'فاكس', salesperson: 'البائع',
      address: 'العنوان', address_en: 'العنوان (إنجليزي)', address_ar: 'العنوان (عربي)',
      country: 'الدولة', province: 'المحافظة', district: 'المنطقة / الحي', street: 'الشارع',
      building: 'المنزل', apartment: 'الشقة', postal_code: 'الرمز البريدي', landmark: 'علامة مميزة',
      additional: 'إضافي', activity_type: 'نوع النشاط', shipping_method: 'الشحن عن طريق',
      reference: 'المرجع', additional_info: 'معلومات إضافية',
      add_location: '+ إضافة موقع', edit_location: 'تعديل الموقع', new_location: 'موقع جديد',
      no_locations: 'لا توجد مواقع بعد', access_notes: 'ملاحظات الوصول', gps_lat: 'خط العرض', gps_lng: 'خط الطول',
      deactivate_location: 'هل تريد إلغاء تفعيل هذا الموقع؟',
      equipment_categories: 'فئات المعدات', manage_categories: 'إدارة أنواع المعدات وقوائم الفحص',
      add_category: '+ إضافة فئة', edit_category: 'تعديل الفئة', new_category: 'فئة جديدة',
      icon_emoji: 'الأيقونة (إيموجي)', sort_order: 'ترتيب العرض', description: 'الوصف',
      checklist_builder: 'قائمة الفحص الافتراضية', add_item: 'إضافة', add_checklist_item: 'أضف عنصر فحص...',
      deactivate: 'إلغاء تفعيل', activate: 'تفعيل',
      // Maintenance Plans
      maintenance_plans: 'خطط الصيانة', maintenance_plans_desc: 'جدولة الصيانة الدورية للمعدات',
      new_plan: 'خطة جديدة', edit_plan: 'تعديل خطة الصيانة',
      create_plan: 'إنشاء خطة', update_plan: 'تحديث الخطة',
      total_plans: 'إجمالي الخطط', active_plans: 'نشطة', paused_plans: 'متوقفة',
      overdue: 'متأخرة', due_this_week: 'مستحقة هذا الأسبوع',
      plan_title: 'العنوان', search_plans: 'بحث في الخطط...', no_plans: 'لا توجد خطط صيانة',
      recurrence: 'التكرار', recurrence_schedule: 'جدول التكرار', recurrence_type: 'نوع التكرار',
      interval: 'الفترة', day_of_period: 'اليوم',
      daily: 'يومي', weekly: 'أسبوعي', monthly: 'شهري', quarterly: 'ربع سنوي',
      semi_annual: 'نصف سنوي', annual: 'سنوي', custom: 'مخصص', every: 'كل',
      next_due: 'الاستحقاق التالي', estimated_hours: 'المدة المقدرة (ساعات)',
      start_date: 'تاريخ البدء', end_date: 'تاريخ الانتهاء',
      auto_work_order: 'إنشاء أمر عمل تلقائي',
      auto_generate_wo_label: 'إنشاء أوامر عمل تلقائياً عند الاستحقاق',
      advance_days: 'إنشاء أمر عمل (أيام قبل الاستحقاق)',
      instructions: 'التعليمات', instructions_en: 'التعليمات (إنجليزي)', instructions_ar: 'التعليمات (عربي)',
      no_equipment_for_client: 'لا توجد معدات لهذا العميل', selected: 'محدد', equipment_count: 'المعدات',
      title_en: 'العنوان (إنجليزي)', title_ar: 'العنوان (عربي)',
      contract: 'العقد', no_contract: 'بدون عقد', priority: 'الأولوية',
      low: 'منخفضة', medium: 'متوسطة', high: 'عالية', critical: 'حرجة',
      confirm_delete: 'هل أنت متأكد من حذف هذه الخطة؟',
      fill_required_fields: 'يرجى تعبئة جميع الحقول المطلوبة',
      add: 'إضافة',
      // Contract page titles
contracts_title: 'عقود الخدمة',
contracts_subtitle: 'إدارة عقود الخدمة واتفاقيات مستوى الخدمة',
new_contract: 'عقد جديد',
edit_contract: 'تعديل العقد',
create_contract: 'إنشاء العقد',
search_contracts: 'بحث في العقود...',
no_contracts: 'لا توجد عقود',
back_to_contracts: 'العودة للعقود',
 
// Contract stat cards
ct_active_contracts: 'العقود النشطة',
ct_expiring_soon: 'ينتهي قريباً',
ct_expired: 'منتهية',
ct_total_value: 'القيمة الإجمالية',
ct_attach_rate: 'نسبة التغطية',
 
// Contract table headers
ct_number: 'رقم العقد',
ct_client: 'العميل',
ct_type: 'النوع',
ct_status: 'الحالة',
ct_start: 'تاريخ البدء',
ct_end: 'تاريخ الانتهاء',
ct_value: 'القيمة',
ct_equipment_count: 'المعدات',
 
// Contract statuses
cst_draft: 'مسودة',
cst_active: 'نشط',
cst_suspended: 'معلق',
cst_expired: 'منتهي',
cst_cancelled: 'ملغي',
cst_renewed: 'مجدد',
 
// Contract types
ctp_warranty: 'ضمان',
ctp_maintenance: 'صيانة',
ctp_full_service: 'خدمة شاملة',
ctp_on_demand: 'عند الطلب',
ctp_custom: 'مخصص',
 
// Filter labels
all_statuses: 'كل الحالات',
all_types: 'كل الأنواع',
all_clients: 'كل العملاء',
 
// Form sections
ct_client_info: 'معلومات العميل',
ct_coverage_period: 'فترة التغطية',
ct_visit_schedule: 'جدول الزيارات',
ct_sla_terms: 'شروط مستوى الخدمة',
ct_financial: 'المالية',
ct_equipment_selection: 'المعدات',
ct_terms_notes: 'الشروط والملاحظات',
 
// Form fields
select_client: 'اختر العميل',
ct_priority: 'الأولوية',
ct_auto_renew: 'تجديد تلقائي',
ct_included_visits: 'الزيارات المشمولة',
ct_unlimited_if_empty: 'اتركه فارغاً لزيارات غير محدودة',
ct_response_time: 'وقت الاستجابة (ساعات)',
ct_resolution_time: 'وقت الحل (ساعات)',
ct_coverage: 'نوع التغطية',
ct_business_hours: 'جدول ساعات العمل',
ct_default_hours: 'الافتراضي',
ct_penalty_clause: 'شرط الغرامة',
ct_penalty_placeholder: 'وصف شروط الغرامة...',
ct_billing: 'دورة الفوترة',
ct_payment_terms: 'مدة الدفع (أيام)',
ct_price_book: 'قائمة الأسعار',
ct_default_pricing: 'التسعير الافتراضي',
ct_terms: 'الشروط والأحكام',
ct_notes: 'ملاحظات داخلية',
ct_select_client_first: 'اختر عميلاً أولاً لعرض المعدات',
ct_no_client_equipment: 'لا توجد معدات لهذا العميل',
 
// Billing cycles
bill_monthly: 'شهري',
bill_quarterly: 'ربع سنوي',
bill_semi_annual: 'نصف سنوي',
bill_annual: 'سنوي',
bill_one_time: 'مرة واحدة',
 
// Coverage types
cov_business: 'ساعات العمل',
cov_247: '24/7',
cov_custom: 'مخصص',
 
// Priority levels
pri_low: 'منخفض',
pri_standard: 'عادي',
pri_high: 'عالي',
pri_critical: 'حرج',
 
// Detail page
ct_details: 'تفاصيل العقد',
ct_tab_overview: 'نظرة عامة',
ct_tab_equipment: 'المعدات',
ct_tab_history: 'السجل',
ct_tab_maintenance: 'خطط الصيانة',
ct_maintenance_plans: 'خطط الصيانة',
fsm_work_orders_tab: 'أوامر العمل',
ct_renew: 'تجديد',
ct_expired_label: 'منتهي',
ct_not_found: 'العقد غير موجود',
ct_contract_equipment: 'معدات العقد',
ct_no_equipment: 'لا توجد معدات مرتبطة بهذا العقد',
ct_all_added: 'جميع معدات العميل مضافة بالفعل',
ct_renewal_history: 'سجل التجديدات',
ct_no_history: 'لا يوجد سجل تجديدات',
ct_cost_incurred: 'التكلفة المتكبدة',
days: 'يوم',
price_books_title: "قوائم الأسعار",
price_books_subtitle: "إدارة أسعار العمالة والمضاعفات وهامش القطع",
new_price_book: "قائمة أسعار جديدة",
edit_price_book: "تعديل قائمة الأسعار",
no_price_books: "لا توجد قوائم أسعار",
pb_labor: "العمالة/ساعة",
pb_overtime: "العمل الإضافي",
pb_emergency: "الطوارئ",
pb_markup: "هامش القطع",
default_label: "افتراضي",
set_as_default: "تعيين كافتراضي",
name_en: "الاسم (EN)",
name_ar_label: "الاسم (AR)",
description: "الوصف",
currency: "العملة",
business_hours_title: "ساعات العمل",
business_hours_subtitle: "تحديد الجداول الأسبوعية لحساب وقت مستوى الخدمة",
new_schedule: "جدول جديد",
edit_schedule: "تعديل الجدول",
no_schedules: "لا توجد جداول",
timezone: "المنطقة الزمنية",
bh_format: "الصيغة: HH:MM-HH:MM (اتركه فارغاً ليوم إجازة)",
day_off: "إجازة",
day_sun: "الأحد",
day_mon: "الاثنين",
day_tue: "الثلاثاء",
day_wed: "الأربعاء",
day_thu: "الخميس",
day_fri: "الجمعة",
day_sat: "السبت",
save: "حفظ",
 
// Validation
err_select_client: 'يرجى اختيار عميل',
err_dates_required: 'تاريخ البدء والانتهاء مطلوبان',
 
// Common (may already exist — skip if duplicate)
cancel: 'إلغاء',
saving: 'جاري الحفظ...',
save_changes: 'حفظ التغييرات',
edit: 'تعديل',
remove: 'إزالة',
add_equipment: 'إضافة معدة',

    },
    en: {
      equipment_registry: 'Equipment Registry', manage_equipment: 'Manage all maintained equipment and assets',
      add_equipment: '+ Add Equipment', edit_equipment: 'Edit Equipment', new_equipment: 'Register New Equipment',
      equipment: 'Equipment', total_equipment: 'Total Equipment', clients: 'Clients', locations: 'Locations',
      warranty_expiring: 'Warranty Expiring', breakdown_alert: 'Breakdown Alert',
      search_equipment: 'Search equipment...', all_categories: 'All Categories', all_clients: 'All Clients', all_status: 'All Status',
      qr_code: 'QR Code', category: 'Category', client: 'Client', location: 'Location', status: 'Status', warranty: 'Warranty', actions: 'Actions',
      active: 'Active', inactive: 'Inactive', maintenance: 'Maintenance', retired: 'Retired',
      brand: 'Brand', model: 'Model', serial_number: 'Serial Number',
      installation_date: 'Installation Date', warranty_expiry: 'Warranty Expiry', floor: 'Floor', unit: 'Unit',
      notes: 'Notes', save: 'Save', saving: 'Saving...', cancel: 'Cancel', edit: 'Edit', delete: 'Delete', close: 'Close',
      loading: 'Loading...', no_equipment: 'No equipment found', add_first: 'Add your first equipment to get started',
      overview: 'Overview', photos: 'Photos', checklist: 'Checklist',
      equipment_details: 'Equipment Details', location_client: 'Location & Client', visit_stats: 'Visit Stats',
      total_visits: 'Total Visits', last_visit: 'Last Visit', next_visit: 'Next Visit',
      no_visits_yet: 'No visits yet', not_scheduled: 'Not scheduled', breakdowns_12m: 'Breakdowns (12mo)',
      download_png: 'Download PNG', no_checklist: 'No checklist defined for this category', no_photos: 'No photos yet',
      warranty_active: 'Warranty Active', warranty_expired: 'Warranty Expired',
      select_client: 'Select client...', select_location: 'Select location (optional)...', select_category: 'Select category...',
      client_location: 'Client & Location', equipment_info: 'Equipment Details', name_en: 'Name (English)', name_ar: 'Name (Arabic)',
      scan_qr_info: 'Print this QR code and affix it to the equipment. Technicians can scan it with the mobile app, and customers can scan to check warranty status or report faults.',
      default_checklist_for: 'Default Maintenance Checklist for',
      fsm_clients: 'FSM Clients', click_info: 'Click 📍 for locations, 🔧 for equipment',
      add_client: '+ Add Client', edit_client: 'Edit Client', new_client: 'New Client', search_clients: 'Search clients...',
      company: 'Company', contact: 'Contact', phone: 'Phone', city: 'City', type: 'Type',
      company_type: 'Company', individual_type: 'Individual', code: 'Code', no_clients: 'No clients yet',
      basic_info: 'Basic Information', client_code: 'Client Code', also_vendor: 'Also Vendor',
      price_list_only: 'Price List Only', prevent_credit: 'Prevent Credit',
      financial: 'Financial', balance: 'Balance', loyalty_balance: 'Loyalty Balance', credit_limit: 'Credit Limit',
      category_1: 'Category', category_2: 'Category 2', contract_from: 'Contract From', contract_to: 'Contract To',
      tax_registration: 'Tax & Registration', tax_number: 'Tax Number', commercial_reg: 'Commercial Reg No.',
      tax_file: 'Tax File No.', tax_code: 'Tax Code', sub_tax_code: 'Sub Tax Code', tax_exemption: 'Tax Exemption',
      contact_info: 'Contact Information', contact_name: 'Contact Name', contact_ar: 'Contact (Arabic)',
      email: 'Email', website: 'Website', alt_phone: 'Alt Phone', fax: 'Fax', salesperson: 'Salesperson',
      address: 'Address', address_en: 'Address (English)', address_ar: 'Address (Arabic)',
      country: 'Country', province: 'Province', district: 'District', street: 'Street',
      building: 'Building', apartment: 'Apartment', postal_code: 'Postal Code', landmark: 'Landmark',
      additional: 'Additional', activity_type: 'Activity Type', shipping_method: 'Shipping Method',
      reference: 'Reference', additional_info: 'Additional Info',
      add_location: '+ Add Location', edit_location: 'Edit Location', new_location: 'New Location',
      no_locations: 'No locations yet', access_notes: 'Access Notes', gps_lat: 'GPS Latitude', gps_lng: 'GPS Longitude',
      deactivate_location: 'Deactivate this location?',
      equipment_categories: 'Equipment Categories', manage_categories: 'Manage equipment types and default checklists',
      add_category: '+ Add Category', edit_category: 'Edit Category', new_category: 'New Category',
      icon_emoji: 'Icon (Emoji)', sort_order: 'Sort Order', description: 'Description',
      checklist_builder: 'Default Maintenance Checklist', add_item: 'Add', add_checklist_item: 'Add checklist item...',
      deactivate: 'Deactivate',
      activate: 'Activate',
      maintenance_plans: 'Maintenance Plans',
      maintenance_plans_desc: 'Schedule recurring maintenance for equipment',
      new_plan: 'New Plan',
      edit_plan: 'Edit Maintenance Plan',
      create_plan: 'Create Plan',
      update_plan: 'Update Plan',
      total_plans: 'Total Plans',
      active_plans: 'Active',
      paused_plans: 'Paused',
      overdue: 'Overdue',
      due_this_week: 'Due This Week',
      plan_title: 'Title',
      search_plans: 'Search plans...',
      no_plans: 'No maintenance plans found',
      recurrence: 'Recurrence',
      recurrence_schedule: 'Recurrence Schedule',
      recurrence_type: 'Recurrence Type',
      interval: 'Interval',
      day_of_period: 'Day',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      semi_annual: 'Semi-Annual',
      annual: 'Annual',
      custom: 'Custom',
      every: 'Every',
      next_due: 'Next Due',
      estimated_hours: 'Est. Duration (hrs)',
      auto_work_order: 'Auto Work Order Generation',
      auto_generate_wo_label: 'Automatically generate work orders when due',
      advance_days: 'Generate WO (days before due)',
      add_checklist_item: 'Add checklist item...',
      instructions_en: 'Instructions (EN)',
      instructions_ar: 'Instructions (AR)',
      no_equipment_for_client: 'No equipment found for this client',
      selected: 'selected',
      equipment_count: 'Equipment',
      no_contract: 'No Contract',
      confirm_delete: 'Are you sure you want to delete this plan?',
 
contracts_title: 'Service Contracts',
contracts_subtitle: 'Manage service contracts and SLA agreements',
new_contract: 'New Contract',
edit_contract: 'Edit Contract',
create_contract: 'Create Contract',
search_contracts: 'Search contracts...',
no_contracts: 'No contracts found',
back_to_contracts: 'Back to Contracts',
 
ct_active_contracts: 'Active Contracts',
ct_expiring_soon: 'Expiring Soon',
ct_expired: 'Expired',
ct_total_value: 'Total Value',
ct_attach_rate: 'Attach Rate',
 
ct_number: 'Contract #',
ct_client: 'Client',
ct_type: 'Type',
ct_status: 'Status',
ct_start: 'Start Date',
ct_end: 'End Date',
ct_value: 'Value',
ct_equipment_count: 'Equipment',
 
cst_draft: 'Draft',
cst_active: 'Active',
cst_suspended: 'Suspended',
cst_expired: 'Expired',
cst_cancelled: 'Cancelled',
cst_renewed: 'Renewed',
 
ctp_warranty: 'Warranty',
ctp_maintenance: 'Maintenance',
ctp_full_service: 'Full Service',
ctp_on_demand: 'On Demand',
ctp_custom: 'Custom',
 
all_statuses: 'All Statuses',
all_types: 'All Types',
all_clients: 'All Clients',
 
ct_client_info: 'Client & Basic Info',
ct_coverage_period: 'Coverage Period',
ct_visit_schedule: 'Visit Schedule',
ct_sla_terms: 'SLA Terms',
ct_financial: 'Financial',
ct_equipment_selection: 'Equipment',
ct_terms_notes: 'Terms & Notes',
 
select_client: 'Select Client',
ct_priority: 'Priority',
ct_auto_renew: 'Auto-Renew',
ct_included_visits: 'Included Visits',
ct_unlimited_if_empty: 'Leave empty for unlimited',
ct_response_time: 'Response Time (hours)',
ct_resolution_time: 'Resolution Time (hours)',
ct_coverage: 'Coverage Type',
ct_business_hours: 'Business Hours Schedule',
ct_default_hours: 'Default',
ct_penalty_clause: 'SLA Penalty Clause',
ct_penalty_placeholder: 'Describe penalty terms...',
ct_billing: 'Billing Cycle',
ct_payment_terms: 'Payment Terms (days)',
ct_price_book: 'Price Book',
ct_default_pricing: 'Default Pricing',
ct_terms: 'Terms & Conditions',
ct_notes: 'Internal Notes',
ct_select_client_first: 'Select a client first to see their equipment',
ct_no_client_equipment: 'No equipment found for this client',
 
bill_monthly: 'Monthly',
bill_quarterly: 'Quarterly',
bill_semi_annual: 'Semi-Annual',
bill_annual: 'Annual',
bill_one_time: 'One-Time',
 
cov_business: 'Business Hours',
cov_247: '24/7',
cov_custom: 'Custom',
 
pri_low: 'Low',
pri_standard: 'Standard',
pri_high: 'High',
pri_critical: 'Critical',
 
ct_details: 'Contract Details',
ct_tab_overview: 'Overview',
ct_tab_equipment: 'Equipment',
ct_tab_history: 'History',
ct_tab_maintenance: 'Maintenance Plans',
ct_maintenance_plans: 'Maintenance Plans',
fsm_work_orders_tab: 'Work Orders',
ct_renew: 'Renew',
ct_expired_label: 'Expired',
ct_not_found: 'Contract not found',
ct_contract_equipment: 'Contract Equipment',
ct_no_equipment: 'No equipment linked to this contract',
ct_all_added: 'All client equipment is already in this contract',
ct_renewal_history: 'Renewal History',
ct_no_history: 'No renewal history',
ct_cost_incurred: 'Cost Incurred',
days: 'days',
price_books_title: "Price Books",
price_books_subtitle: "Manage labor rates, multipliers, and parts markup",
new_price_book: "New Price Book",
edit_price_book: "Edit Price Book",
no_price_books: "No price books yet",
pb_labor: "Labor/hr",
pb_overtime: "Overtime",
pb_emergency: "Emergency",
pb_markup: "Parts Markup",
default_label: "Default",
set_as_default: "Set as default",
name_en: "Name (EN)",
name_ar_label: "Name (AR)",
description: "Description",
currency: "Currency",
business_hours_title: "Business Hours",
business_hours_subtitle: "Define weekly schedules for SLA clock calculation",
new_schedule: "New Schedule",
edit_schedule: "Edit Schedule",
no_schedules: "No schedules yet",
timezone: "Timezone",
bh_format: "Format: HH:MM-HH:MM (leave empty for day off)",
day_off: "Off",
day_sun: "Sunday",
day_mon: "Monday",
day_tue: "Tuesday",
day_wed: "Wednesday",
day_thu: "Thursday",
day_fri: "Friday",
day_sat: "Saturday",
save: "Save",
 
err_select_client: 'Please select a client',
err_dates_required: 'Start and end dates are required',
 
cancel: 'Cancel',
saving: 'Saving...',
save_changes: 'Save Changes',
edit: 'Edit',
remove: 'Remove',
add_equipment: 'Add Equipment',
    }
  },

  // ===== Layout / Sidebar =====
  sidebar: {
    ar: {
      brand: 'MatixERP Agent',
      dashboard: 'لوحة التحكم',
      all_conversations: 'كل المحادثات',
      helpdesk: 'الدعم الفني',
      leads: 'العملاء المحتملين',
      marketing: 'حملات التسويق',
      booking_calendar: 'حجز اجتماع',
      my_bookings: 'حجوزاتي',
      negative_feedback: 'التقييمات السلبية',
      clients: 'العملاء',
      agents: 'الموظفين',
      canned_responses: 'الردود الجاهزة',
      analytics: 'التحليلات',
      departments: 'الأقسام',
      organizations: 'المؤسسات',
      teams: 'الفرق',
      logout: 'تسجيل الخروج',
      settings: 'الإعدادات',
      my_profile: 'ملفي الشخصي',
      event_types: 'أنواع الأحداث',
      availability: 'أوقات التوفر',
      online: 'متصل',
      offline: 'غير متصل',
      field_service: 'الخدمة الميدانية',
      communications: 'المحادثات',
      comms_short: 'محادثات',
      helpdesk_module: 'الدعم الفني',
      helpdesk_short: 'دعم فني',
      fsm_short: 'صيانة',
      admin: 'الإدارة',
      admin_short: 'إدارة',
      settings_lookup: 'الإعدادات',
      fsm_equipment: 'المعدات',
      fsm_clients: 'عملاء الخدمة',
      fsm_categories: 'فئات المعدات',fsm_contracts: 'العقود',fsm_price_books: 'قوائم الأسعار',fsm_business_hours: 'ساعات العمل',
      fsm_work_orders: 'أوامر العمل', fsm_maintenance_plans: 'خطط الصيانة', fsm_reports: 'التقارير', fsm_technicians: 'الفنيين', fsm_dispatch: 'لوحة التوزيع',
      visitsExhausted: 'تم استنفاد الزيارات',
      notEntitled: 'غير مستحق',
      entitled: 'مستحق',
      entitlementStatus: 'حالة الاستحقاق',
      qrServiceRequest: 'طلب خدمة عبر QR',
      noActiveContract: 'لا يوجد عقد نشط',
      expiringSoon: 'ينتهي قريباً',
      contractHealth: 'حالة العقد',
      coveredEquipment: 'المعدات المغطاة',
      visitsRemaining: 'الزيارات المتبقية',
      requestService: 'طلب خدمة',
      myContracts: 'عقودي',
      serviceRequest: 'طلب خدمة',
      previewPdf: 'معاينة PDF',
      printWo: 'طباعة أمر العمل',
      downloadPdf: 'تحميل PDF',
      fsm_dashboard: 'لوحة التحكم',
      fsm_contract_templates: 'قوالب العقود',
      fsm_wo_templates: 'قوالب أوامر العمل',
      fsm_parts_catalog: 'كتالوج القطع',

    },
    en: {
      brand: 'MatixERP Agent',
      dashboard: 'Dashboard',
      all_conversations: 'All Conversations',
      helpdesk: 'Helpdesk',
      leads: 'Leads',
      marketing: 'Marketing',
      booking_calendar: 'Book Meeting',
      my_bookings: 'My Bookings',
      negative_feedback: 'Bad Reviews',
      clients: 'Clients',
      agents: 'Agents',
      canned_responses: 'Canned Responses',
      analytics: 'Analytics',
      departments: 'Departments',
      organizations: 'Organizations',
      teams: 'Teams',
      logout: 'Logout',
      settings: 'Settings',
      my_profile: 'My Profile',
      event_types: 'Event Types',
      availability: 'Availability',
      online: 'Online',
      offline: 'Offline',
      field_service: 'Field Service',
      communications: 'Communications',
      comms_short: 'Comms',
      helpdesk_module: 'Helpdesk',
      helpdesk_short: 'Helpdesk',
      fsm_short: 'FSM',
      admin: 'Admin',
      admin_short: 'Admin',
      settings_lookup: 'Settings',
      fsm_equipment: 'Equipment',
      fsm_clients: 'FSM Clients',
      fsm_categories: 'Categories',fsm_work_orders: 'Work Orders', fsm_contracts: 'Contracts',fsm_price_books: 'Price Books',fsm_business_hours: 'Business Hours', fsm_technicians: 'Technicians', fsm_dispatch: 'Dispatch Board',

    }
  },

  // ===== Leads Page =====
  leads: {
    ar: {
      page_title: '🛒 إدارة العملاء المحتملين (Leads)',
      last_update: 'آخر تحديث:',
      add_lead: '➕ إضافة Lead',
      // Stats
      stat_total: 'إجمالي Leads',
      stat_today: 'اليوم',
      stat_overdue: '⏰ متابعات متأخرة',
      stat_follow_today: '📅 متابعات اليوم',
      stat_won: '✅ مكسب',
      stat_demo: 'ديمو محجوز',
      // Filters
      search_placeholder: '🔍 بحث...',
      filter_all_status: 'كل الحالات',
      filter_new: 'جديد',
      filter_contacted: 'تم التواصل',
      filter_demo_scheduled: 'ديمو محجوز',
      filter_demo_done: 'ديمو تم',
      filter_negotiation: 'تفاوض',
      filter_won: 'كسبناه',
      filter_lost: 'خسرناه',
      filter_all_levels: 'كل المستويات',
      filter_hot: '🔥 ساخن',
      filter_warm: '🟡 دافئ',
      filter_cold: '🔵 بارد',
      filter_all_followups: 'كل المتابعات',
      filter_overdue: '⏰ متأخرة',
      filter_today: '📅 اليوم',
      filter_upcoming: '🔜 هذا الأسبوع',
      filter_none: '❌ بدون متابعة',
      // Table
      col_id: '#',
      col_customer: 'العميل',
      col_company: 'الشركة',
      col_phone: 'الرقم',
      col_interest: 'الاهتمام',
      col_status: 'الحالة',
      col_followup: 'المتابعة',
      col_date: 'التاريخ',
      col_actions: 'إجراءات',
      loading: '⏳ جارٍ التحميل...',
      no_leads: 'لا يوجد leads',
      unknown: 'غير معروف',
      prev_page: '← السابق',
      next_page: 'التالي →',
      page_of: 'صفحة {page} من {total} ({count})',
      // Badges
      badge_hot: '🔥 ساخن',
      badge_warm: '🟡 دافئ',
      badge_cold: '🔵 بارد',
      badge_new: 'جديد',
      badge_contacted: 'تم التواصل',
      badge_demo_scheduled: 'ديمو محجوز',
      badge_demo_done: 'ديمو تم',
      badge_negotiation: 'تفاوض',
      badge_won: '✅ كسبناه',
      badge_lost: '❌ خسرناه',
      fu_overdue: '⏰ متأخر',
      fu_today: '📅 اليوم',
      fu_soon: '🔜 قريب',
      // Edit Modal
      edit_title: '🛒 Lead #{id} - {name}',
      tab_details: '✏️ التفاصيل',
      tab_notes: '📝 ملاحظات',
      tab_followup: '⏰ متابعة',
      label_name: 'اسم العميل',
      label_company: 'الشركة',
      label_phone: 'رقم الهاتف',
      label_size: 'حجم الشركة',
      label_industry: 'النشاط',
      label_budget: 'الميزانية',
      label_status: 'الحالة',
      label_interest: 'مستوى الاهتمام',
      label_source: 'المصدر',
      label_demo_date: 'موعد الديمو',
      label_modules: 'الموديولات المطلوبة',
      label_needs: 'ملخص الاحتياج',
      label_conversation: 'المحادثة',
      messages_count: '{count} رسالة',
      btn_delete: '🗑️ حذف',
      btn_book_demo: '📅 حجز ديمو',
      btn_cancel: 'إلغاء',
      btn_save: '💾 حفظ',
      btn_saving: '⏳...',
      save_failed: 'فشل في حفظ التعديلات',
      // Notes tab
      note_placeholder: 'اكتب ملاحظة جديدة...',
      note_shortcut: 'Ctrl+Enter للإرسال',
      note_add: '➕ إضافة',
      note_adding: '⏳...',
      note_empty: 'لا توجد ملاحظات',
      note_delete_confirm: 'حذف؟',
      note_failed: 'فشل',
      // Follow-up tab
      fu_scheduled: '📅 متابعة مجدولة',
      fu_completed_btn: '✅ تمت المتابعة',
      fu_reschedule: '📝 تعديل / إعادة جدولة',
      fu_new: '➕ جدولة متابعة جديدة',
      fu_datetime: 'تاريخ ووقت المتابعة',
      fu_note: 'ملاحظة المتابعة',
      fu_note_placeholder: 'مثال: تأكيد موعد الديمو...',
      fu_quick_1h: 'بعد ساعة',
      fu_quick_tom10: 'غداً 10ص',
      fu_quick_tom2: 'غداً 2م',
      fu_quick_3d: 'بعد 3 أيام',
      fu_quick_1w: 'بعد أسبوع',
      fu_save: '📅 حفظ المتابعة',
      fu_saved: 'تم جدولة المتابعة ✅',
      fu_save_failed: 'فشل في حفظ المتابعة',
      fu_done: 'تمت المتابعة بنجاح ✅',
      wa_btn: '💬 راسله واتساب',
      call_btn: '📞 اتصل',
      no_phone: 'لا يوجد رقم هاتف',
      // Delete
      delete_title: 'تأكيد حذف Lead #{id}',
      delete_warn: 'سيتم حذف كل الملاحظات والمتابعات!',
      delete_no_undo: 'لا يمكن التراجع!',
      delete_btn: '🗑️ احذف',
      delete_deleting: '⏳...',
      delete_failed: 'فشل الحذف',
      status_change_failed: 'فشل تغيير الحالة',
      // Add Modal
      add_title: '➕ إضافة Lead جديد',
      add_ph_name: 'مثال: أحمد محمد',
      add_ph_phone: '966501234567',
      add_ph_company: 'مثال: شركة المتقدمة',
      add_email: 'البريد الإلكتروني',
      add_ph_email: 'email@company.com',
      add_interest: 'مستوى الاهتمام',
      add_industry: 'المجال / النشاط',
      add_ph_industry: 'مطاعم، تجارة، خدمات...',
      add_size: 'حجم الشركة',
      add_source: 'المصدر',
      add_needs: 'ملخص الاحتياج',
      add_ph_needs: 'وصف مختصر لاحتياج العميل...',
      add_notes: 'ملاحظات',
      add_ph_notes: 'أي ملاحظات إضافية...',
      add_save: '💾 حفظ Lead',
      add_saving: '⏳ جاري الحفظ...',
      add_choose: '-- اختر --',
      add_s1: '1-5 موظفين', add_s2: '6-20 موظف', add_s3: '21-50 موظف', add_s4: '51-100 موظف', add_s5: 'أكثر من 100',
      add_src_manual: 'إدخال يدوي', add_src_call: 'مكالمة هاتفية', add_src_wa: 'واتساب',
      add_src_web: 'الموقع الإلكتروني', add_src_ref: 'إحالة / توصية', add_src_social: 'سوشيال ميديا',
      add_src_expo: 'معرض', add_src_other: 'أخرى',
      add_err_required: 'يجب إدخال رقم الهاتف أو اسم العميل على الأقل',
      add_err_connection: 'حدث خطأ في الاتصال',
    },
    en: {
      page_title: '🛒 Leads Management',
      last_update: 'Last update:',
      add_lead: '➕ Add Lead',
      stat_total: 'Total Leads',
      stat_today: 'Today',
      stat_overdue: '⏰ Overdue Follow-ups',
      stat_follow_today: '📅 Follow-ups Today',
      stat_won: '✅ Won',
      stat_demo: 'Demo Booked',
      search_placeholder: '🔍 Search...',
      filter_all_status: 'All Statuses',
      filter_new: 'New',
      filter_contacted: 'Contacted',
      filter_demo_scheduled: 'Demo Scheduled',
      filter_demo_done: 'Demo Done',
      filter_negotiation: 'Negotiation',
      filter_won: 'Won',
      filter_lost: 'Lost',
      filter_all_levels: 'All Levels',
      filter_hot: '🔥 Hot',
      filter_warm: '🟡 Warm',
      filter_cold: '🔵 Cold',
      filter_all_followups: 'All Follow-ups',
      filter_overdue: '⏰ Overdue',
      filter_today: '📅 Today',
      filter_upcoming: '🔜 This Week',
      filter_none: '❌ No Follow-up',
      col_id: '#',
      col_customer: 'Customer',
      col_company: 'Company',
      col_phone: 'Phone',
      col_interest: 'Interest',
      col_status: 'Status',
      col_followup: 'Follow-up',
      col_date: 'Date',
      col_actions: 'Actions',
      loading: '⏳ Loading...',
      no_leads: 'No leads found',
      unknown: 'Unknown',
      prev_page: '← Previous',
      next_page: 'Next →',
      page_of: 'Page {page} of {total} ({count})',
      badge_hot: '🔥 Hot',
      badge_warm: '🟡 Warm',
      badge_cold: '🔵 Cold',
      badge_new: 'New',
      badge_contacted: 'Contacted',
      badge_demo_scheduled: 'Demo Booked',
      badge_demo_done: 'Demo Done',
      badge_negotiation: 'Negotiation',
      badge_won: '✅ Won',
      badge_lost: '❌ Lost',
      fu_overdue: '⏰ Overdue',
      fu_today: '📅 Today',
      fu_soon: '🔜 Soon',
      edit_title: '🛒 Lead #{id} - {name}',
      tab_details: '✏️ Details',
      tab_notes: '📝 Notes',
      tab_followup: '⏰ Follow-up',
      label_name: 'Customer Name',
      label_company: 'Company',
      label_phone: 'Phone Number',
      label_size: 'Company Size',
      label_industry: 'Industry',
      label_budget: 'Budget',
      label_status: 'Status',
      label_interest: 'Interest Level',
      label_source: 'Source',
      label_demo_date: 'Demo Date',
      label_modules: 'Interested Modules',
      label_needs: 'Needs Summary',
      label_conversation: 'Conversation',
      messages_count: '{count} messages',
      btn_delete: '🗑️ Delete',
      btn_book_demo: '📅 Book Demo',
      btn_cancel: 'Cancel',
      btn_save: '💾 Save',
      btn_saving: '⏳...',
      save_failed: 'Failed to save changes',
      note_placeholder: 'Write a new note...',
      note_shortcut: 'Ctrl+Enter to send',
      note_add: '➕ Add',
      note_adding: '⏳...',
      note_empty: 'No notes yet',
      note_delete_confirm: 'Delete?',
      note_failed: 'Failed',
      fu_scheduled: '📅 Scheduled Follow-up',
      fu_completed_btn: '✅ Mark Complete',
      fu_reschedule: '📝 Edit / Reschedule',
      fu_new: '➕ Schedule New Follow-up',
      fu_datetime: 'Follow-up Date & Time',
      fu_note: 'Follow-up Note',
      fu_note_placeholder: 'e.g. Confirm demo appointment...',
      fu_quick_1h: 'In 1 hour',
      fu_quick_tom10: 'Tomorrow 10AM',
      fu_quick_tom2: 'Tomorrow 2PM',
      fu_quick_3d: 'In 3 days',
      fu_quick_1w: 'In 1 week',
      fu_save: '📅 Save Follow-up',
      fu_saved: 'Follow-up scheduled ✅',
      fu_save_failed: 'Failed to save follow-up',
      fu_done: 'Follow-up completed ✅',
      wa_btn: '💬 WhatsApp',
      call_btn: '📞 Call',
      no_phone: 'No phone number',
      delete_title: 'Confirm Delete Lead #{id}',
      delete_warn: 'All notes and follow-ups will be deleted!',
      delete_no_undo: 'This cannot be undone!',
      delete_btn: '🗑️ Delete',
      delete_deleting: '⏳...',
      delete_failed: 'Delete failed',
      status_change_failed: 'Failed to change status',
      add_title: '➕ Add New Lead',
      add_ph_name: 'e.g. Ahmed Mohamed',
      add_ph_phone: '966501234567',
      add_ph_company: 'e.g. Advanced Co.',
      add_email: 'Email',
      add_ph_email: 'email@company.com',
      add_interest: 'Interest Level',
      add_industry: 'Industry',
      add_ph_industry: 'Restaurants, Retail, Services...',
      add_size: 'Company Size',
      add_source: 'Source',
      add_needs: 'Needs Summary',
      add_ph_needs: 'Brief description of customer needs...',
      add_notes: 'Notes',
      add_ph_notes: 'Any additional notes...',
      add_save: '💾 Save Lead',
      add_saving: '⏳ Saving...',
      add_choose: '-- Select --',
      add_s1: '1-5 employees', add_s2: '6-20 employees', add_s3: '21-50 employees', add_s4: '51-100 employees', add_s5: '100+',
      add_src_manual: 'Manual Entry', add_src_call: 'Phone Call', add_src_wa: 'WhatsApp',
      add_src_web: 'Website', add_src_ref: 'Referral', add_src_social: 'Social Media',
      add_src_expo: 'Exhibition', add_src_other: 'Other',
      add_err_required: 'Phone number or customer name is required',
      add_err_connection: 'Connection error',
    }
  },

  // ===== Common =====
  common: {
    ar: { error: 'خطأ', success: 'تم بنجاح', confirm: 'تأكيد', cancel: 'إلغاء', save: 'حفظ', delete: 'حذف', edit: 'تعديل', close: 'إغلاق', loading: 'جاري التحميل...', no_data: 'لا توجد بيانات' },
    en: { error: 'Error', success: 'Success', confirm: 'Confirm', cancel: 'Cancel', save: 'Save', delete: 'Delete', edit: 'Edit', close: 'Close', loading: 'Loading...', no_data: 'No data' }
  },

  // ===== Agent Form =====
  agent_form: {
    ar: {
      edit_agent: 'تعديل موظف',
      create_new_agent: 'إنشاء موظف جديد',
      basic_information: 'المعلومات الأساسية',
      full_name: 'الاسم الكامل',
      username: 'اسم المستخدم',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      whatsapp_number: 'رقم الواتساب',
      role: 'الدور',
      password: 'كلمة المرور',
      password_placeholder: 'الحد الأدنى 6 أحرف',
      role_agent: 'موظف',
      role_supervisor: 'مشرف',
      role_admin: 'مدير',
      work_settings: 'إعدادات العمل',
      service_type: 'نوع الخدمة',
      service_all: 'الكل',
      service_sales: 'مبيعات',
      service_support: 'دعم فني',
      timezone: 'المنطقة الزمنية',
      priority_score: 'درجة الأولوية (0-100)',
      max_conversations: 'الحد الأقصى للمحادثات',
      work_start_time: 'وقت بداية العمل',
      work_end_time: 'وقت نهاية العمل',
      auto_assign_bot: 'التعيين التلقائي للمحادثات',
      enable_auto_assignment: 'تفعيل التعيين التلقائي',
      conversation_types: 'أنواع المحادثات',
      technical: 'فني',
      sales: 'مبيعات',
      conv_types_help: 'اختر أنواع المحادثات لهذا الموظف. اتركها فارغة لاستقبال جميع الأنواع.',
      countries: 'الدول',
      countries_help: 'اختر الدول لهذا الموظف. اتركها فارغة لجميع الدول.',
      permissions: 'الصلاحيات',
      skills_specializations: 'المهارات والتخصصات',
      languages: 'اللغات',
      helpdesk_departments: 'أقسام الدعم الفني',
      country_kw: 'الكويت',
      country_sa: 'السعودية',
      country_eg: 'مصر',
      country_other: 'أخرى',
      page_title: 'إدارة الموظفين',
      page_subtitle: 'إدارة مستخدمي النظام وصلاحياتهم',
      add_new_agent: '+ إضافة موظف جديد',
      loading_agents: 'جاري تحميل الموظفين...',
      no_agents_found: 'لا يوجد موظفون',
      no_agents_help: 'أنشئ أول موظف لبدء إدارة المحادثات.',
      col_name: 'الاسم',
      col_username: 'اسم المستخدم',
      col_email: 'البريد الإلكتروني',
      col_role: 'الدور',
      col_status: 'الحالة',
      col_actions: 'الإجراءات',
      status_active: 'نشط',
      status_inactive: 'غير نشط',
      btn_permissions: '🔐 الصلاحيات',
      btn_edit: 'تعديل',
      btn_delete: 'حذف',
      btn_schedule: '⏰ الجدولة',
    },
    en: {
      edit_agent: 'Edit Agent',
      create_new_agent: 'Create New Agent',
      basic_information: 'Basic Information',
      full_name: 'Full Name',
      username: 'Username',
      email: 'Email',
      phone: 'Phone',
      whatsapp_number: 'WhatsApp Number',
      role: 'Role',
      password: 'Password',
      password_placeholder: 'Minimum 6 characters',
      role_agent: 'Agent',
      role_supervisor: 'Supervisor',
      role_admin: 'Admin',
      work_settings: 'Work Settings',
      service_type: 'Service Type',
      service_all: 'All',
      service_sales: 'Sales',
      service_support: 'Support',
      timezone: 'Timezone',
      priority_score: 'Priority Score (0-100)',
      max_conversations: 'Max Conversations',
      work_start_time: 'Work Start Time',
      work_end_time: 'Work End Time',
      auto_assign_bot: 'Auto Assign Bot Conversation',
      enable_auto_assignment: 'Enable Auto-Assignment',
      conversation_types: 'Conversation Types',
      technical: 'Technical',
      sales: 'Sales',
      conv_types_help: 'Select conversation types this agent should receive. Leave both unchecked for all types.',
      countries: 'Countries',
      countries_help: 'Select countries this agent handles. Leave empty for all countries.',
      permissions: 'Permissions',
      skills_specializations: 'Skills & Specializations',
      languages: 'Languages',
      helpdesk_departments: 'Helpdesk Departments',
      country_kw: 'Kuwait',
      country_sa: 'Saudi Arabia',
      country_eg: 'Egypt',
      country_other: 'Others',
      page_title: 'Agents Management',
      page_subtitle: 'Manage system users and their permissions',
      add_new_agent: '+ Add New Agent',
      loading_agents: 'Loading agents...',
      no_agents_found: 'No agents found',
      no_agents_help: 'Create your first agent to start managing conversations.',
      col_name: 'Name',
      col_username: 'Username',
      col_email: 'Email',
      col_role: 'Role',
      col_status: 'Status',
      col_actions: 'Actions',
      status_active: 'Active',
      status_inactive: 'Inactive',
      btn_permissions: '🔐 Permissions',
      btn_edit: 'Edit',
      btn_delete: 'Delete',
      btn_schedule: '⏰ Schedule',
    }
  }
};

// =====================================================
// PROVIDER
// =====================================================
export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('app_language') || 'ar';
  });

  useEffect(() => {
    localStorage.setItem('app_language', lang);
    // Set document direction
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLang = () => setLang(prev => prev === 'ar' ? 'en' : 'ar');

  // Get translations for a specific section
  const t = (section) => {
    if (translations[section] && translations[section][lang]) {
      return translations[section][lang];
    }
    return {};
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// =====================================================
// HOOK
// =====================================================
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export default LanguageContext;
